import {map} from '../map/map';
import api from '../api/index';
import customConnect from '../customConnect';
import centerOnFeatures from '../map/centerOnFeatures';
import {drawSource, drawLayer, getGeometries, style, modify} from './mapAssets';
import {drawFeaturesChange} from './actions';
import { isMax } from './reducer';

import {Snap, Draw} from 'ol/interaction.js';
import GeoJSON from 'ol/format/GeoJSON.js';


map.addInteraction(modify);

var draw = null;
var snap = null; 
var rulerType = false;

snap = new Snap({source: drawSource});

map.addLayer(drawLayer);

function changeType(type) {

    if(type === "") {

        return;
    }

    if(rulerType) {
       
        rulerType = false;
    }

    if(type === 'RulerPolygon') {
        rulerType = 'polygon';
        type = 'Polygon';
    }
    if(type === 'RulerLine') {
        rulerType = 'line';
        type = "LineString";
    }
    

    if(draw !== null) {
        map.removeInteraction(draw);
        draw = null;
    }

    

    draw = new Draw({
      source: drawSource,
      type: type,
      condition: function(e) {
		  // when the point's button is 1(leftclick), allows drawing
		  if (e.pointerEvent.buttons === 1) { 
		    return true;
		  } else {
		    return false;
		  }
		}
    });
    
    map.addInteraction(draw);

    
    
}

function enableDrawing(type) {

	//special case for ruler
	if(draw !== null) {
    //    map.addInteraction(draw);
    }
    
    map.addInteraction(snap);
    
}



  function disableDrawing() {

  	if(rulerType) {

  		rulerType = false;
  	}
  	
  	

    map.removeInteraction(draw);
    map.removeInteraction(snap);

    draw = null;
  //  map.removeInteraction(modify);


  }

  function enable() {

    enableDrawing();
    
  }

  function disable() {
  	//clear();
    disableDrawing();

  //  map.removeLayer(drawLayer);
  }

var drawChangeCallback = null;
var timeout = false;

drawSource.on('change', (ev) => {


	if(typeof drawChangeCallback === 'function'){

		if(timeout) {
			clearTimeout(timeout);
		}

		timeout = setTimeout(function() {
			drawChangeCallback(getGeometries()); 
			
		}, 5);
		
	}
});

var clear = function() {

	if(drawLayer.getSource().getFeatures().length > 0) {


		drawLayer.getSource().clear();
	}

};

//CHANGE DRAW TYPE
var stateUpdateHandlerDraw = function(props) { //called when state updates
	

	changeType(props.type);


	drawChangeCallback = props.drawFeaturesChange;
};

//DISABLE /  ENABLE
var stateUpdateHandler = function(props) { //called when state updates
	
	if(props.maxGeom && modify.getActive()) {

		modify.setActive(false);
	} else if(!modify.getActive()) {

		modify.setActive(true);
	}

	if(props.active) {
		

		enable();
	} else {
		
		disable();
	}
};

//Loads features from state
var stateUpdateHandlerFeatures = function(props) {
	

	if(props.updateSource == 'OL') {
		return;
	}

	var format = new GeoJSON();
	var features = format.readFeatures(props.featuresGeoJSON);


/*	for (var i = features.length - 1; i >= 0; i--) {
		var props = features[i].getProperties();

		if(props.specialType === 'ruler') {
			draw = new Draw({
		      source: drawSource,
		      type: type
		    });

		    setRulerEvents(draw, modify);
	    
		} else if (props.specialType === 'circle') {
			//wip			
		}
	}*/

    drawSource.clear();
	drawSource.addFeatures(features);

};



export default function (store) { //new props and action function


    //DRAW BUTTON CLICK
	customConnect((state) => {

		return {
			type: state.draw.drawType
		};
	}, (dispatch) => {

	  return {drawFeaturesChange: (data)=>{ 

	  	dispatch(drawFeaturesChange({GeoJSON: data}));
	  }};
	}, store, stateUpdateHandlerDraw);

    //ENABLE / DISABLE
	customConnect((state) => {

        if(isMax(state.draw)) {
            var enabled = false;
        } else {
            var enabled = state.draw.drawType !== ""; //state.draw.drawType !== "";
        }

		return {
			maxGeom: isMax(state.draw),
			active: enabled
		};
	}, (dispatch) => {

	  return {};
	}, store, stateUpdateHandler);


	customConnect((state) => {

		return {
			featuresGeoJSON: state.draw.featuresGeoJSON,
			updateSource: state.draw.updateSource,
		};
	}, (dispatch) => {return {};}, store, stateUpdateHandlerFeatures);
}